import { Component } from 'react'
import { IListProps, IListState } from '../types'
import styles from '../index.module.less'
import { YBackGroundImage } from '@/utils/style-methods'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from '../trackConfig'
import classNames from 'classnames'
import { isFullCn } from '@/utils/font'
// 指定行数：填写默认指定行数和显示加载行数。最多展示十行。
// todo: 优化：图片懒加载
// todo: 优化：下拉加载更多
@withReactTrack({ createTrackConfig })
export class LineBrand extends Component<IListProps, IListState> {
  render() {
    // 数据筛选
    const brandList = this.props.brandList
    const len = brandList.length > 30 ? 30 : brandList.length - (brandList.length % 3)
    const data = brandList.slice(0, len)

    return (
      <div className={styles['line-brand']}>
        {data.map((item) => {
          const style = YBackGroundImage(item.brandBackImg, 3 * 280)
          const iconStyle = YBackGroundImage(item.brandLogo, 3 * 36)

          return (
            <div
              className={styles['line-brand-box']}
              key={item.brandName}
              onClick={() => this.props.goToDetail(item)}
              data-track-click="poizon_venue_component_content_click"
              data-track-exposure="poizon_venue_component_content_exposure"
              data-blockType="1641"
              data-url={item.redirectValue}
            >
              {/* 图 */}
              <div className={styles['brand-img']} style={style}></div>
              {/* 标记 */}
              <div className={styles['brand-icon']} style={iconStyle}></div>
              {/* 品牌名称 */}
              <div
                className={classNames({
                  [styles['brand-name']]: true,
                  [styles['brand-en']]: !isFullCn(item.brandName),
                })}
              >
                {item.brandName}
              </div>
              <div className={styles['brand-desc']}>{item.interestDesc}</div>
            </div>
          )
        })}
      </div>
    )
  }
}
